import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { deleteStudyPlanCall, getStudyPlanCall } from "../../redux/api/studyPlan.api";
import { masteryEmoji } from "./data";
import StudyShell from "./StudyShell";

export default function StudyPlanPage() {
  const { planId } = useParams();
  const navigate = useNavigate();
  const [plan, setPlan] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    getStudyPlanCall(planId).then((response) => {
      if (!alive) return;
      if (!response?.plan) {
        setError(response?.message || "This study plan could not be opened.");
        setPlan(null);
      } else {
        setPlan(response.plan);
        setError("");
      }
      setLoading(false);
    });
    return () => {
      alive = false;
    };
  }, [planId]);

  const remove = async () => {
    if (!plan) return;
    const ok = window.confirm(`Delete “${plan.title || plan.subject}”?`);
    if (!ok) return;
    const response = await deleteStudyPlanCall(plan.id);
    if (response?.code) {
      setError(response.message || "This study could not be deleted.");
      return;
    }
    navigate("/study");
  };

  const progress = Math.max(0, Math.min(100, Number(plan?.progress) || 0));

  return (
    <StudyShell>
      <button type="button" className="study-link" onClick={() => navigate("/study")}>Study Hub</button>
      {loading ? <CircularProgress size={28} sx={{ mt: 2 }} /> : null}
      {error ? <div className="study-error">{error}</div> : null}
      {plan ? (
        <>
          <section className="study-hero" style={{ marginTop: 14 }}>
            <div className="study-kicker">{plan.subject}</div>
            <h1>{plan.title || plan.subject}</h1>
            <p>
              {plan.topicsDone || 0} of {plan.topicsTotal || 0} topics finished
              {plan.examName ? ` · ${plan.examName}` : ""}
              {plan.examDate ? ` · ${plan.examDate}` : ""}
            </p>
            <div className="study-bar" style={{ marginTop: 18, background: "rgba(255,255,255,0.16)" }}>
              <span style={{ width: `${progress}%` }} />
            </div>
            <div className="study-hero-actions">
              <button type="button" className="study-ghost" onClick={remove}>Delete plan</button>
            </div>
          </section>
          <div className="study-section">
            <h2>Topics</h2>
          </div>
          <div className="study-grid">
            {(plan.topics || []).map((topic) => {
              const done = topic.lesson?.status === "completed";
              const mastery = topic.lesson?.masteryPercent;
              return (
                <article className="study-card" key={topic.id}>
                  <div className="study-card-top">
                    <h3>{topic.title}</h3>
                    <span>{mastery != null ? masteryEmoji(mastery) : done ? "✓" : ""}</span>
                  </div>
                  <div className="study-meta">
                    {done ? "Completed" : topic.lesson ? "In progress" : "Not started"}
                    {mastery != null ? ` · ${mastery}% mastery` : ""}
                  </div>
                  <div className="study-card-actions">
                    <button
                      type="button"
                      className="go"
                      onClick={() => navigate(`/study/plan/${plan.id}/topic/${topic.id}`)}
                    >
                      {topic.lesson ? "Continue" : "Start"}
                    </button>
                  </div>
                </article>
              );
            })}
          </div>
        </>
      ) : null}
    </StudyShell>
  );
}
